// extracted by mini-css-extract-plugin
export default {"wrap":"JobboardMobileUpgradeStrip_wrap__oBCQ1","inlineSlot":"JobboardMobileUpgradeStrip_inlineSlot__Laz+8","wrapLayoutFlow":"JobboardMobileUpgradeStrip_wrapLayoutFlow__GFxLO"};